import PhotosSearchBrowseModalContainer from '../src/PhotosSearchBrowse/PhotosSearchBrowseModalContainer';
export default PhotosSearchBrowseModalContainer;
